import { render } from "./StaffResultsTab.vue?vue&type=template&id=78882e28"
import script from "./StaffResultsTab.vue?vue&type=script&lang=js"
export * from "./StaffResultsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__